.sectionHeader {
    display: flex;
    align-items: center;
    margin: 0.3rem 0;
}

.sectionHeader > :global(h3),
.sectionHeader > :global(h4),
.sectionHeader > :global(h5),
.sectionHeader > :global(h6) {
    margin: 0 !important;
}

.sectionHeader:hover {
    background-color: #f0f3fa;
    border-radius: 0.3rem;
    margin: 0.3rem -0.3rem;
    padding: 0 0.3rem;
}

.headerOptions {
    display: flex;
    margin-left: auto;
}

.buttonContainer {
    display: flex;
    flex-wrap: nowrap;
    flex-shrink: 0;
}

.iconButton {
    color: #1498b3;
    margin-left: 0.3rem;
    /* 3.75px pad → 24.375 × 30.75px box around a 16.875px icon. */
    padding: 0.234375rem;
    border-radius: 0.25rem;
    background: none;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.iconButton svg {
    height: 1.0547rem;
    width: 1.0547rem;
}

.iconButton:hover {
    background: rgba(0, 0, 0, 0.05);
}

.iconButton span {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.augmentedContent {
    display: flex;
    flex-direction: row;
}

.augmentedContent .headerOptions {
    align-items: flex-start;
}

.augmentedContent .headerOptions .iconButton {
    box-sizing: border-box;
    height: 1.25rem;
    width: 1.25rem;
}

/* Inline comment buttons sit in a 20×20 box with 3.75px padding, leaving
   only 12.5×12.5 of inner space. The default `.iconButton svg`
   1.0547rem (≈16.875px) size overflows that and gets flex-clipped to
   12.5×16.875 — non-square, off-shape. Hardcode 12px to fit cleanly. */
.augmentedContent .headerOptions .iconButton svg {
    height: 12px;
    width: 12px;
}

.contentContainer {
    flex: 1;
}
